var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('use',{attrs:{"xlink:href":"assets/map/train.svg#train","x":_vm.train.x,"y":_vm.train.y,"transform":_vm.train.transform}})}
var staticRenderFns = []

export { render, staticRenderFns }